import { API } from "../../lib/api";
import { Download, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

export default function AdminReports() {
  const dl = async (path, name) => {
    try {
      const token = localStorage.getItem("gf_token");
      const r = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("err");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = name;
      a.click(); URL.revokeObjectURL(url);
    } catch (_) { toast.error("Failed to download"); }
  };

  const reports = [
    { title: "Lots Report", desc: "All lots with status, owners, expenses, profits.", path: "/reports/admin/lots", name: "lots_report.xlsx", testid: "rpt-lots",
      gradient: "linear-gradient(135deg, #D71921 0%, #B0151E 100%)" },
    { title: "Sales Report", desc: "All processed sales with invoices, expenses, profits.", path: "/reports/admin/sales", name: "sales_report.xlsx", testid: "rpt-sales",
      gradient: "linear-gradient(135deg, #B8862A 0%, #8E6517 100%)" },
  ];

  return (
    <div>
      {/* Hero banner */}
      <div className="relative overflow-hidden rounded-3xl mb-8 p-8 md:p-10 text-white"
        style={{ background: "linear-gradient(135deg, #1F1816 0%, #7A1010 60%, #D71921 100%)" }}>
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#F2C97A]/25 blur-3xl" />
        <div className="absolute -bottom-32 -left-16 w-72 h-72 rounded-full bg-[#3F6B3F]/20 blur-3xl" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/20 text-xs font-bold uppercase tracking-widest mb-3">
            Excel exports
          </div>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight">Reports</h1>
          <p className="text-white/80 mt-2 max-w-xl">Download Excel reports for accounting and analysis.</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {reports.map((r) => (
          <div key={r.title} className="relative overflow-hidden rounded-2xl p-6 text-white" style={{ background: r.gradient }}>
            <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-white/10 blur-xl" />
            <FileSpreadsheet className="w-7 h-7 text-[#F2C97A] relative" />
            <div className="font-display text-2xl mt-3 relative">{r.title}</div>
            <p className="text-sm text-white/85 mt-1 relative">{r.desc}</p>
            <button onClick={() => dl(r.path, r.name)} data-testid={r.testid}
              className="relative mt-5 px-4 py-2.5 rounded-xl bg-white text-[#1F1816] text-sm font-semibold hover:bg-[#FCEDED] flex items-center gap-2">
              <Download className="w-4 h-4" /> Download Excel
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
